import { SftpSummaryStatsApiResponse } from "../../data-model/sftpSummaryStatsModel";
import { ApiBaseUrls } from "../../enums/apiUrls";
import { logDataToConsole, logError } from "../../utils/customLogger";
import { getOrgIdForFetchExternalWorklist } from "../../utils/organizationHelper";
import { getAuthHeaders, handleApiResponse } from "../utils/apiHelpers";

export interface SftpSummaryStatsParams {
  page?: number;
  page_size?: number;
}

/**
 * Fetches SFTP summary stats from the backend service
 * @param params - Query parameters including page and page_size
 * @param signal - Optional AbortSignal for canceling the request
 * @returns Promise with the API response
 */
export const getSftpSummaryStats = async (
  params: SftpSummaryStatsParams,
  signal?: AbortSignal,
): Promise<SftpSummaryStatsApiResponse> => {
  const orgId = getOrgIdForFetchExternalWorklist();
  const { page = 1, page_size = 10 } = params;

  const queryParams = new URLSearchParams({
    org_id: orgId,
    page: String(page),
    page_size: String(page_size),
  });

  const url = `${ApiBaseUrls.BACKEND_SERVICE}pharmacy/summary-stats?${queryParams.toString()}`;

  try {
    const headers = await getAuthHeaders();

    const requestOptions: RequestInit = {
      method: "GET",
      headers,
      redirect: "follow",
      signal,
    };

    const response = await fetch(url, requestOptions);
    const result = await handleApiResponse(response);
    logDataToConsole("getSftpSummaryStats", result);
    return result;
  } catch (error) {
    if ((error as Error).name === "AbortError") {
      logDataToConsole("getSftpSummaryStats", "Request aborted");
      throw error;
    }
    logError(error as Error, "Error in getSftpSummaryStats");
    throw error;
  }
};
